<script setup lang="ts">
import { ListboxGroup, ListboxGroupLabel, type ListboxGroupProps, useId } from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes, normalizeClass, onMounted, onUnmounted } from "vue";

import { provideCommandGroupContext, useCommand } from "./index.ts";

const props = defineProps<
	ListboxGroupProps & {
		class?: HTMLAttributes["class"];
		heading?: string;
	}
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const { allGroups, filterState } = useCommand();
const id = useId();

const isRender = computed(() => (!filterState.search ? true : filterState.filtered.groups.has(id)));

provideCommandGroupContext({ id });
onMounted(() => {
	if (!allGroups.value.has(id)) allGroups.value.set(id, new Set());
});
onUnmounted(() => {
	allGroups.value.delete(id);
});
</script>

<template>
	<ListboxGroup
		v-bind="delegatedProps"
		:id="id"
		:class="
			twMerge(
				'overflow-hidden p-1 text-foreground **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground',
				normalizeClass(props.class),
			)
		"
		:hidden="isRender ? undefined : true"
	>
		<ListboxGroupLabel v-if="heading" class="text-muted-foreground px-2 py-1.5 text-xs font-medium">
			{{ heading }}
		</ListboxGroupLabel>
		<slot />
	</ListboxGroup>
</template>
